import { useSelector } from 'react-redux';
import { useMemo } from 'react';

export interface CompanyInfo {
    ruc: string;
    nombreComercial: string;
    ambiente: string;
    firmaDigital: string;
    logoUrl: string | null;
}

export const useCompanyInfo = (): CompanyInfo => {
    const selectedCompany = useSelector((state: any) => state.Companies.selectedCompany);

    const companyInfo = useMemo(() => {
        if (selectedCompany) {
            return {
                ruc: selectedCompany.ruc || 'N/A',
                nombreComercial: selectedCompany.tradeName || selectedCompany.businessName || 'N/A',
                ambiente: selectedCompany.environmentType === 1 ? 'Pruebas' : 'Producción',
                firmaDigital: selectedCompany.signatures && selectedCompany.signatures.length > 0 ? 'Activa' : 'No configurada',
                logoUrl: selectedCompany.logoUrl || null
            };
        }
        return {
            ruc: '---',
            nombreComercial: '---',
            ambiente: '---',
            firmaDigital: '---',
            logoUrl: null
        };
    }, [selectedCompany]);

    return companyInfo;
};
